// ════════════════════════════════════════
// ForgotPassword.jsx
// ════════════════════════════════════════
import React, { useState } from 'react';
import { toast } from '../utils/swal';
import './Login.css';

export const ForgotPassword = ({ onBack }) => {
  const [email, setEmail]   = useState('');
  const [sent, setSent]     = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { toast.warning('Email adresi gereklidir.'); return; }

    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      // Her durumda başarı göster (güvenlik)
      setSent(true);
    } catch {
      setSent(true); // Yine de göster
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <div className="login-logo-icon">🎭</div>
          <h1 className="login-logo-text">Gişe Görevlisi</h1>
          <p className="login-logo-sub">Bilet Rezervasyon Sistemi</p>
        </div>

        {sent ? (
          <div className="login-form">
            <div className="fp-success">
              <div className="fp-success-icon">📧</div>
              <h2>Email gönderildi</h2>
              <p>Şifre sıfırlama bağlantısı email adresinize gönderildi. Lütfen gelen kutunuzu kontrol edin.</p>
              <p className="fp-note">Bağlantı 30 dakika geçerlidir.</p>
            </div>
            <button className="login-btn" onClick={onBack}>Giriş sayfasına dön</button>
          </div>
        ) : (
          <form className="login-form" onSubmit={handleSubmit}>
            <h2 className="login-title">Şifremi Unuttum</h2>
            <p className="fp-desc">Email adresinizi girin, şifre sıfırlama bağlantısı gönderelim.</p>
            <div className="login-field">
              <label>Email</label>
              <input
                type="email"
                placeholder="ornek@email.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoFocus
              />
            </div>
            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? 'Gönderiliyor...' : 'Sıfırlama Bağlantısı Gönder'}
            </button>
          </form>
        )}

        <div className="login-footer">
          <button className="login-register-link" onClick={onBack}>← Giriş sayfasına dön</button>
        </div>
      </div>
    </div>
  );
};


// ════════════════════════════════════════
// ResetPassword.jsx
// ════════════════════════════════════════
export const ResetPassword = ({ token, onSuccess }) => {
  const [form, setForm]       = useState({ password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) { toast.warning('Şifre en az 8 karakter olmalıdır.'); return; }
    if (form.password !== form.confirm) { toast.warning('Şifreler eşleşmiyor.'); return; }

    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword: form.password })
      });

      if (!res.ok) {
        const err = await res.json();
        toast.error(err.error || 'Şifre sıfırlanamadı.');
        return;
      }

      toast.success('Şifreniz başarıyla güncellendi!');
      onSuccess();
    } catch {
      toast.error('Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-logo">
            <div className="login-logo-icon">🎭</div>
            <h1 className="login-logo-text">Gişe Görevlisi</h1>
          </div>
          <div className="login-form">
            <div className="fp-success">
              <div className="fp-success-icon">⚠️</div>
              <h2>Geçersiz bağlantı</h2>
              <p>Bu şifre sıfırlama bağlantısı geçersiz veya süresi dolmuş.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <div className="login-logo-icon">🎭</div>
          <h1 className="login-logo-text">Gişe Görevlisi</h1>
          <p className="login-logo-sub">Bilet Rezervasyon Sistemi</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <h2 className="login-title">Yeni Şifre Belirle</h2>

          <div className="login-field">
            <label>Yeni Şifre</label>
            <div className="login-pass-wrap">
              <input
                type={showPass ? 'text' : 'password'}
                placeholder="En az 8 karakter"
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                autoFocus
              />
              <button type="button" className="login-pass-toggle" onClick={() => setShowPass(!showPass)}>
                {showPass ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <div className="login-field">
            <label>Şifre Tekrar</label>
            <input
              type={showPass ? 'text' : 'password'}
              placeholder="Şifrenizi tekrar girin"
              value={form.confirm}
              onChange={e => setForm({ ...form, confirm: e.target.value })}
            />
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Güncelleniyor...' : 'Şifremi Güncelle'}
          </button>
        </form>
      </div>
    </div>
  );
};
